import { AlertCircle, Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

type StateBlockProps = {
  title: string;
  detail?: string;
  action?: ReactNode;
};

export function LoadingState() {
  const { t } = useTranslation("common");
  return (
    <div className="grid min-h-52 place-items-center">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" />
        {t("states.loading")}
      </div>
    </div>
  );
}

export function EmptyState({ title, detail, action }: StateBlockProps) {
  return (
    <div className="grid min-h-48 place-items-center rounded-md border border-dashed bg-panel px-4 py-10 text-center">
      <div className="max-w-md">
        <div className="font-medium">{title}</div>
        {detail ? <div className="mt-1 text-sm text-muted-foreground">{detail}</div> : null}
        {action ? <div className="mt-4">{action}</div> : null}
      </div>
    </div>
  );
}

export function ErrorState({ title, detail, onRetry }: StateBlockProps & { onRetry?: () => void }) {
  const { t } = useTranslation("common");
  return (
    <div className="rounded-md border bg-panel p-4">
      <div className="flex items-start gap-3">
        <AlertCircle className="mt-0.5 h-5 w-5 text-destructive" />
        <div className="min-w-0 flex-1">
          <div className="font-medium">{title}</div>
          {detail ? <div className="mt-1 text-sm text-muted-foreground">{detail}</div> : null}
        </div>
        {onRetry ? (
          <Button variant="outline" size="sm" onClick={onRetry}>
            {t("actions.retry")}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
